import { useContext } from 'react';

import DeleteCompareModalContext from './deleteCompareModal.context';

function useDeleteCompareModal() {
  const context = useContext(DeleteCompareModalContext);

  if (!context) {
    throw new Error('useDeleteCompareModal must be used within DeleteCompareModalContext');
  }

  return context;
}

export default useDeleteCompareModal;